export default {
  SET_TEMPLATES(state, data) {
    state.templates = data;
  },
  SET_TEMPLATE(state, data) {
    state.template = data;
  },
}
